import { RouteInfo } from "./app-navigation.metadata";
import { INDICATOR_REPORTING_NAVIGATION_ITEMS } from "src/app/+indicator-reporting/shared/indicator-reporting-navigation";

const INDICATOR_REPORTING_ROUTES: RouteInfo[] =
  INDICATOR_REPORTING_NAVIGATION_ITEMS.map((item) => ({
    path: item.route,
    title: item.label,
    iconType: "material-icons-outlined",
    icon: item.icon,
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: [...item.permissions],
    submenu: [],
  }));

export const ROUTES: RouteInfo[] = [
  // Dashboard Section
  {
    path: "",
    title: "Overview",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: '/dashboard/forecast-dashboard',
    title: 'Forecast Dashboard',
    iconType: 'material-icons-outlined',
    icon: 'show_chart', // Minimal line chart
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    submenu: [],
    permission: ["dashboard.forecast.view"],
  },
  {
    path: '/forlabpluslaunchedpad',
    title: 'Launch Pad',
    iconType: 'material-icons-outlined',
    icon: 'rocket_launch',
    class: '',
    groupTitle: false,
    badge: '',
    badgeClass: '',
    submenu: [],
  },
  {
    path: "/dashboard/rdf-dashboard",
    title: "RDF Dashboard",
    iconType: "material-icons-outlined",
    icon: "grid_view", // Minimal grid
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["dashboard.rdf.view"],
    submenu: [],
  },
  {
    path: "/dashboard/program-dashboard",
    title: "Program Dashboard",
    iconType: "material-icons-outlined",
    icon: "medical_services", // Minimal cross/health
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["dashboard.program.view"],
    submenu: [],
  },
  {
    path: "/dashboard/facility",
    title: "Facility Dashboard",
    iconType: "material-icons-outlined",
    icon: "business", // Minimal building
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["dashboard.facility.view"],
    submenu: [],
  },
  {
    path: '/community-feed',
    title: 'Community Feed',
    iconType: 'material-icons-outlined',
    icon: 'forum',
    class: '',
    groupTitle: false,
    badge: 'New',
    badgeClass: 'badge-purple',
    permission: ["community.view"],
    submenu: [],
  },

  // Requests/Forms
  {
    path: "",
    title: "Requests",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/request/new-request",
    title: "New Request",
    iconType: "material-icons-outlined",
    icon: "post_add", // Minimal add doc
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
    permission: ["orders.manage"],
  },
  {
    path: "/request/my-request",
    title: "My Requests",
    iconType: "material-icons-outlined",
    icon: "list_alt", // Minimal list
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["orders.view"],
    submenu: [],
  },

  // Logistics
  {
    path: "",
    title: "Logistics",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/non-cdss-demand",
    title: "NON-CDSS MVS",
    iconType: "material-icons-outlined",
    icon: "inventory_2", // Minimal box
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["orders.manage"],
    submenu: [],
  },
  {
    path: "/cdss/monitoring",
    title: "CDSS Monitoring",
    iconType: "material-icons-outlined",
    icon: "visibility",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["cdss.monitor"],
    submenu: [],
  },
  {
    path: "/cdss/agreement",
    title: "CDSS Agreement",
    iconType: "material-icons-outlined",
    icon: "assignment",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["orders.manage"],
    submenu: [],
  },
  // Forecasting
  {
    path: "",
    title: "Forecasting",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/forecasting/copilot",
    title: "Forecasts",
    iconType: "material-icons-outlined",
    icon: "trending_up",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["forecasting.view"],
    submenu: [],
  },

  // Planning
  {
    path: "",
    title: "Planning",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/supply-planning/submission-status",
    title: "Supply Planning Status",
    iconType: "material-icons-outlined",
    icon: "fact_check", // Minimal checklist
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["supplyplanning.monitor"],
    submenu: [],
  },
  ...INDICATOR_REPORTING_ROUTES,
  {
    path: "/supply-planning",
    title: "Supply Plan",
    iconType: "material-icons-outlined",
    icon: "local_shipping", // Minimal truck
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["supplyplanning.view"],
    submenu: [],
  },
  {
    path: "/supply-planning/program-assumptions",
    title: "Program Assumptions",
    iconType: "material-icons-outlined",
    icon: "biotech",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["program.manage", "supplyplanning.admin"],
    submenu: [],
  },
  {
    path: "/rrf-planning",
    title: "RRF Planning",
    iconType: "material-icons-outlined",
    icon: "assignment", // Minimal clipboard
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["supplyplanning.view"],
    submenu: [],
  },

  // Reports
  {
    path: "",
    title: "Reports",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/report/product-report",
    title: "Procurement Request",
    iconType: "material-icons-outlined",
    icon: "shopping_bag", // Minimal bag
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["reports.view"],
    submenu: [],
  },
  {
    path: "/report/forecast-analysis",
    title: "Forecast Analysis",
    iconType: "material-icons-outlined",
    icon: "analytics",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["reports.view"],
    submenu: [],
  },
  {
    path: "/report/program-report",
    title: "Program Report",
    iconType: "material-icons-outlined",
    icon: "pie_chart", // Minimal chart
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["reports.view"],
    submenu: [],
  },

  // Help
  {
    path: "",
    title: "Help",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
  },
  {
    path: "/micro-learning",
    title: "Training Videos",
    iconType: "material-icons-outlined",
    icon: "play_circle_outline", // Minimal play outline
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    submenu: [],
  },

  // Admin
  {
    path: "",
    title: "Administration",
    iconType: "",
    icon: "",
    class: "",
    groupTitle: true,
    badge: "",
    badgeClass: "",
    submenu: [],
    permission: ["users.manage", "metadata.manage", "settings.manage"],
  },
  {
    path: "/user/users",
    title: "User Management",
    iconType: "material-icons-outlined",
    icon: "people_outline", // Minimal people outline
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["users.manage"],
    submenu: [],
  },
  {
    path: "/lookup/roles-permissions",
    title: "Roles and Permissions",
    iconType: "material-icons-outlined",
    icon: "admin_panel_settings",
    class: "",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["roles.manage"],
    submenu: [],
  },
  {
    path: "/configuration/edit",
    title: "Settings",
    iconType: "material-icons-outlined",
    icon: "settings", // Minimal gear
    class: "menu-toggle",
    groupTitle: false,
    badge: "",
    badgeClass: "",
    permission: ["settings.manage", "metadata.manage"],
    submenu: [
      {
        path: "/laboratory/laboratories",
        title: "Facilities",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        permission: ["facilities.manage"],
        submenu: [],
      },
      {
        path: "/product/products",
        title: "Products",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        permission: ["products.manage"],
        badge: "",
        badgeClass: "",
        submenu: [],
      },
      {
        path: "/vendor/vendors",
        title: "Vendors",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        permission: ["vendors.manage"],
        badgeClass: "",
        submenu: [],
      },
      {
        path: "lookup/regions",
        title: "Regions",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        permission: ["metadata.manage"],
        badge: "",
        badgeClass: "",
        submenu: [],
      },
      {
        path: "lookup/zones",
        title: "Zones",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        permission: ["metadata.manage"],
        badge: "",
        badgeClass: "",
        submenu: [],
      },
      {
        path: "lookup/oncology-master-list",
        title: "Oncology Master List",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        permission: ["metadata.manage"],
        badge: "",
        badgeClass: "",
        submenu: [],
      },
      {
        path: "lookup/woredas",
        title: "Woredas",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        permission: ["metadata.manage"],
        badge: "",
        badgeClass: "",
        submenu: [],
      },
      {
        path: "/lookup/laboratory-levels",
        title: "Facility Levels",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        permission: ["metadata.manage"],
      },
      {
        path: "lookup/config",
        title: "Config",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        permission: ["settings.manage"],
      },
      {
        path: "/user/chat-balance-management",
        title: "Chat Balance",
        iconType: "",
        icon: "",
        class: "ml-menu",
        groupTitle: false,
        badge: "",
        badgeClass: "",
        submenu: [],
        permission: ["chat.balance.manage"],
      },
    ],
  },
];
